<template>
    <div id="main">
        <div class="page">
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{$t('adiantamentos')}}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li><a class="a-inativo">{{$t('despesas')}}</a></li>
                                <li>
                                    <a @click="$router.push({ name : 'des-adiantamentos-list' })" aria-current="page">
                                        {{$t('adiantamentos')}}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                <div class="header-buttons">
                <!-- <button class="save-btn" type="button" tag="button" @click="$router.push({ name : 'des-datepicker' })">
                Datepicker
                </button> -->
                <button 
                    v-if="permissao.create" 
                    class="save-btn" 
                    type="button" 
                    tag="button" 
                    @click="$router.push({ name : 'des-adiantamentos-new' })"
                >
                    {{ $t('adicionar') }}
                </button>
            </div>
            </div>
                <!-- FILTROS -->
                <div class="search-and-filter">
                    <div class="columns is-variables is-desktop">
                        <div class="column header-search is-4">
                            <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-acertos" width="40"/>
                        </div>
                        <!-- Data Inicio-->
                        <div class="column is-3 ">
                            <verified-date-picker
                                :dateType="'startDate'"
                                v-model="datainicial"
                                :endDate="datafinal"
                                :title="'data-inicio'"
                                @carregarDados="carregarDados()"
                            />
                        </div>
                        <!-- Data Fim-->
                        <div class="column is-3">
                            <verified-date-picker
                                :dateType="'endDate'"
                                v-model="datafinal"
                                :startDate="datainicial"
                                :title="'data-fim'"
                                @carregarDados="carregarDados()"
                            />
                        </div>
                        <!-- SITUACAO -->
                        <div class="situacao-select column is-2">
                            <label v-text="$t('situacao')"/>
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label ) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t( option.label ) }}
                                </template>
                                <template slot="no-options">{{$t('sem-resultados')}}</template>
                            </v-select>
                        </div>
                    </div>
                </div>

                <!--Tabela-->
                <section class="registry-wrapper mt-2">
                    <container-loader v-if="isLoading && !$store.getters.isLoading"/>
                    <empty-table-message class="mt-3" v-if="isEmpty"/>
                    <b-table
                        v-else
                        :data="adiantamentos"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <!--COLOCAR OS LABELS PARA OS DICIONARIOS -->
                        <b-table-column 
                            v-for="(f) in fields"
                            :key="f.key + '-' + f.colaborador"
                            :field="f.key"
                            :label="f.key == 'deletar' ? '' : $t(f.key)"
                            :class="{'excluir-field': f.key == 'deletar'}"
                            :width="f.width"
                            :sortable="f.sortable"
                            v-slot="props"
                        >
                            <div 
                                class="has-text-left"
                                v-if="f.key == 'colaborador'"
                            >
                                <a @click="$router.push(
                                    {name : 'des-adiantamentos-view', params: { id: props.row.idadiantamento }}
                                )">
                                    {{ props.row.colaborador }}
                                </a>
                            </div>

                            <div v-else-if="f.key == 'observacao-geral'">
                                {{ props.row[f.key] | cutString() }}
                            </div>

                            <div v-else-if="f.key == 'valor'">
                                {{ props.row.valor | decimal(null, true) }}
                            </div>

                            <div v-else-if="f.key == 'datahorainc'">
                                {{ props.row.datahorainc | moment("L LT") }}
                            </div>

                            <div v-else-if="f.key == 'situacao'" >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    :type="isStatusButtonType(props.row.situacao)"
                                    size="is-medium"
                                    v-if="props.row.situacao!=null||props.row.situacao!=''">
                                    {{ $t(props.row.situacao.toLowerCase()) }}
                                </b-tag>
                            </div>

                            <div v-else-if="f.key == 'deletar'">
                                <b-button  
                                    v-if="props.row.situacao == 'ABERTO' && permissao.delete"
                                    type="is-danger"
                                    @click="promptForDelete(props.row)"
                                    icon-right="delete"
                                    position="is-left"
                                    v-tippy 
                                    :title="$t('desativar')"
                                />
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                        <template slot="footer">
                            <th 
                                v-for="(f) in fields"
                                :key="f.key+'-'+f.nome"
                                :id="f.key"
                            >
                                <span v-if="f.key == 'nome'">{{ acertos.length }} {{ $t('registro') }}</span>
                                <span v-if="f.key == 'valor'">
                                    {{ valorAdiantamentos | decimal(null, true) }}</span>
                                <span v-else></span>
                            </th>
                        </template>
                    </b-table>
                </section>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
    </div>
</div>
</template>

<script>
import AdiantamentoService from  "@/services/despesas/AdiantamentoService"
import ContainerLoader from "@/components/content/loader/ContainerLoader"
import Message from "@/models/Message"

export default {
    components: {
        ContainerLoader,
    }, 
    data() {
        return {
            situacao: {},
            situacoes: [
                { paramQuery: 'EXCLUIDO', label: 'excluidos', id: 0 },
                { paramQuery: 'FECHADO', label: 'fechados', id: 1 }, 
                { paramQuery: 'ABERTO',label: 'abertos', id: 2 }, 
                { paramQuery: 'TODOS', label: 'todos', id: 3 },
            ],
            fields: [
                {key: 'valor', width: 150, sortable: true, label: '', footer: true},
                {key: 'observacao-geral', width: null, sortable: false, footer: false},
                {key: 'colaborador', width: null, sortable: true, label: '', footer: false},
                {key: 'empresa', width: null, sortable: false, label: '', footer: false},
                {key: 'datahorainc', width: 120, sortable: true, label: '', footer: false},
                {key: 'situacao', width: 100, sortable: false, label: '', footer: false},
                {key: 'deletar', width: 45, sortable: false, label: '', footer: false}
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10,25,50,100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1
            },
            msgs: [],
            adiantamentos :[],
            service: new AdiantamentoService(this.$http, this.$router),
            debouncedOnSearch: Function,
            query: '',
            sort: 'data',
            order: 'desc',
            isLoading: true,
            isEmpty: false,
            valorAdiantamentos: 0,
            datainicial: (() => {
                let trintaDiasAtras = new Date();
                trintaDiasAtras.setDate(trintaDiasAtras.getDate() - 31);
                return trintaDiasAtras;
            })(),
            datafinal: new Date(),
            delete: null,
            permissao: {}
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess("despesas", "cadastros", "des-adiantamentos");
        if (!this.permissao.read){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'adiantamentos' }
            });
        } else {
            this.situacao = Object.assign(...this.situacoes.filter(s => s.id == 3))
            this.debouncedOnSearch = this.debounce(this.onSearch, 500)
            this.carregarDados(1)
        }
    },
    methods: {
        updatePagination(value){
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if(currentPage==1&&this.pagination.currentPage!=1)this.pagination.resetPagination=true;
            this.isLoading = true
            let filtro = {
                datainicial: this.datainicial ? this.$moment(this.datainicial).format("YYYY-MM-DD") : null,
                datafinal: this.datafinal ? this.$moment(this.datafinal).format("YYYY-MM-DD") : null,
                situacao: this.situacao.paramQuery
            }
            this.service.findAll(filtro, this.sort, this.order, currentPage - 1, this.pagination.perPage, this.query)
            .then(this.mapItems)
            .then(value => {
                this.adiantamentos = value
                this.isEmpty = this.adiantamentos.length <= 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error("Erro ao carregar os adiantamentos.")
            })
            .finally(_ => {
                this.pagination.resetPagination = false;
                this.isLoading = false
                this.getTotalValue()
            })
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map(m => {
                return {
                    idadiantamento: m.idadiantamento,
                    'observacao-geral': m.obsgeral,
                    colaborador: m.usuario.nome,
                    empresa: m.empresa.nome,
                    valor: m.valor,
                    situacao: m.tipo,
                    datahorainc: m.datahorainc,
                    deletar: "excluir"
                };
            });
            return list;
        },
        //DELETAR
        promptForDelete(row) {
            this.delete = row;
            this.$root.confirm({
                message: this.$t('msg-confirmacao-desativacao-adiantamento-n', 
                    { n: row.colaborador, v: this.getDecimal(row.valor, null, true) }
                ),
                onConfirm: () => this.promptForMotivoDelete(row),
                onCancel: this.removePrompt
            });
        },
        promptForMotivoDelete(row) {
            this.$root.prompt({
                message: this.$t('msg-motivo-desativacao-adiantamento-n', 
                        { n: row.colaborador, v: this.getDecimal(row.valor, null, true) }
                    ),
                confirmText: this.$t('confirmar'),
                onConfirm: this.deletarAdiantamento,
                cancelText: this.$t('cancelar'),
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        deletarAdiantamento(motivo) {
            this.isLoading = true;
            this.service.deleteAdiantamentoById(this.delete.idadiantamento, motivo)
                .then(_ => {
                    this.$root.showMessage('success', 'msg-adiantamento-success-desativar');
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch(e => {
                    console.error("Erro ao remover acerto.", e);
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                })
                .finally(_ => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        isStatusButtonType(status) {
            if(status == 'ABERTO')
                return 'is-danger'
            else if (status == 'FECHADO')
                return 'is-success'
            else if(status == 'EXCLUIDO')
                return 'is-warning'
        },
        parseValueSearch(text){
            //Função para deixar o valor no formato correto para api
            text = text.replace(/[\,]+/g, '.')
            return text
        },
        onSearch(text) {
            //faz replace da virgula pois a busca no banco precisa ser ocm ponto 
            text = this.parseValueSearch(text)
            this.query = this.removeAcentos(text)
            this.carregarDados()
        },
        sortTable(field, order) {
            this.sort = field;
            this.order = order;
            this.carregarDados();
        },
        updateSituacao(situacao) {
            if(situacao != null) this.situacao = Object.assign(...this.situacoes.filter(s => s.id == situacao.id)) 
            else this.situacao = Object.assign(...this.situacoes.filter(s => s.id == 3))
            this.carregarDados();
        },
        getTotalValue() {
            this.valorAdiantamentos = 0
            this.adiantamentos.forEach(adiantamento => {
                this.valorAdiantamentos += adiantamento.valor
            })
        },
        parseDate(date) {
            return this.$moment(date, 'DD-MM-YYYY').toDate()
        },
        showMessage(type, message) {
            this.msgs.push(
                new Message(type, message, true)
            )
        },
    }
}
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    min-height: 100%;
    height: 100%;

    .page {
    position: relative;
    padding-left: 0;
        min-height: 100%;
        height: inherit;

        .situacao-select div{
            height: 40px;
        }
        .calendar-btn {
            padding: 0;
            width: 100px;
            height: 35px;
        }
        .datepicker input{
            height: 40px !important;
        }
        .mt-3 {
            margin-top: 5rem !important;
        }
        .rodape-table-info{
            height: 100%;
        }
        .margin-none {
            margin: 0!important
        }
        .nav.nav-tabs {
            margin-bottom: 0;
            margin-left: -20px;
            padding-left: 20px;
        }
        .table-tag-full-width{
            width: 100%;
        }
    }
}
</style>